import PlaningToolRoot from '../PlaningToolRoot'
import { MItem } from '../Menu'
import { Box } from '@mui/material'
import { useEffect, useMemo, useState } from 'react'
import NewsworthyModule from './NewsworthyModule'
import SalesPotentialChart from './SalesPotentialChart'
import LatestInquiriesModule from './LatestInquiriesModule'
import SalesRankingList from './SalesRankingList'
import { GLItemsDTO, SALES_PIPELINE_STATUSES, SalesChartMode } from '../../../DTO/GLItemsDTO'
import { GLItemKind } from '../../../DTO/GLItemDTO'
import mainservice from '../../../services/MainService'

export default function DashboardDemo() {
  const [dto] = useState(() => new GLItemsDTO({ kind: GLItemKind.marketing }))
  const [loading, setLoading] = useState(true)
  const [dataTick, setDataTick] = useState(0)

  useEffect(() => {
    let cancelled = false
    async function load() {
      setLoading(true)
      await dto.getChartFromServer({ kind: GLItemKind.marketing })
      if (!cancelled) {
        setLoading(false)
        setDataTick(t => t + 1)
      }
    }
    load()
    return () => { cancelled = true }
  }, [dto])

  const topPeople = useMemo(() => {
    void dataTick
    return dto.buildTopPeople(3, 8)
  }, [dto, dataTick])
  const topCustomers = useMemo(() => {
    void dataTick
    return dto.buildTopCustomers(true, 3, 8)
  }, [dto, dataTick])
  const topUnweighted = useMemo(() => {
    void dataTick
    return dto.buildTopCustomers(false, 3, 8)
  }, [dto, dataTick])

  function openChart() {
    mainservice.navTo([
      ['view', 'spMarketingChart'],
      ['status', 'all'],
      ['chartMode', 'company' as SalesChartMode],
    ])
  }

  return (
    <PlaningToolRoot
      standalone
      menuItem={MItem.dashboardDemo}
      mainContentClass="DashboardDemo flex flex-column"
    >
      <div className="contentHeader">
        <h2>Dashboard Demo</h2>
      </div>
      <Box
        sx={{
          padding: 2,
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
            gap: 2,
            alignItems: 'start',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
            }}
          >
            <NewsworthyModule />
            <LatestInquiriesModule />
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
            }}
          >

            <SalesPotentialChart
              mode="company"
              variant="teaser"
              statuses={SALES_PIPELINE_STATUSES}
              groupBy="quarter"
              dto={dto}
              loading={loading}
              dataTick={dataTick}
              onOpenFull={openChart}
            />
            
            <SalesPotentialChart
              title="Gewonnen / Verloren"
              variant="tile"
              groupBy="wonLost"
              yearCount={3}
              dto={dto}
              loading={loading}
              dataTick={dataTick}
            />
            <SalesRankingList
              title="Ungewichtet"
              rows={topUnweighted}
              emptyText="Keine Firmensummen in den letzten drei Jahren"
            />
            <SalesRankingList
              title="Top Kunden"
              rows={topCustomers}
              emptyText="Keine Kunden in den letzten drei Jahren"
            />
            <SalesRankingList
              title="Top Personen"
              rows={topPeople}
              emptyText="Keine Personen in den letzten drei Jahren"
            />
          </Box>
        </Box>
      </Box>
    </PlaningToolRoot>
  )
}
